import * as yup from 'yup';
import { dataProviderKey } from './KidsPlan.enums';
import { providerIds } from './KidsPlan.utils';

export const KidsPlanSchema = yup.object({
  [dataProviderKey.PROVIDER]: yup
    .mixed()
    .transform((val) => (val && typeof val === 'object' ? val.id : val))
    .oneOf(providerIds)
    .required(),
  [dataProviderKey.CUSTOMER_KEY]: yup.string().nullable().default(''),
  [dataProviderKey.USERNAME]: yup.string().required(),
  [dataProviderKey.PASSWORD]: yup.string().required(),
  [dataProviderKey.URL]: yup.string().url().required(),
  [dataProviderKey.AUTH_URL]: yup.string().url().nullable(),
  [dataProviderKey.TOKEN]: yup.string().nullable()
});
